// Search-param schema for /conversation/$id. Drives the right-hand
// spreadsheet side panel: ?sheet={artifact_id}&v={version_num}.
// Shareable, survives refresh.

export interface ConversationSearch {
  sheet?: string
  v?: number
}

export function validateConversationSearch(
  raw: Record<string, unknown>,
): ConversationSearch {
  const out: ConversationSearch = {}
  if (typeof raw.sheet === 'string' && raw.sheet.length > 0) {
    out.sheet = raw.sheet
  }
  if (typeof raw.v === 'number' && Number.isInteger(raw.v) && raw.v >= 1) {
    out.v = raw.v
  } else if (typeof raw.v === 'string') {
    const n = Number.parseInt(raw.v, 10)
    if (Number.isInteger(n) && n >= 1) out.v = n
  }
  return out
}
